import { useState } from "react"
import { auth } from "../firebase"
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth"
import "../Css/Register.css"

export default function Register({ onRegister }) {
  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    email: "",
    password: "",
    confirmPassword: "",
  })
  const [registerStatus, setRegisterStatus] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const validateForm = () => {
    if (!formData.nombre.trim() || !formData.apellido.trim()) {
      setRegisterStatus("Por favor completa todos los campos")
      return false
    }

    if (formData.password.length < 6) {
      setRegisterStatus("La contraseña debe tener al menos 6 caracteres")
      return false
    }

    if (formData.password !== formData.confirmPassword) {
      setRegisterStatus("Las contraseñas no coinciden")
      return false
    }

    return true
  }

  const handleRegister = async (event) => {
    event.preventDefault()
    setRegisterStatus("")

    if (!validateForm()) {
      return
    }

    setIsLoading(true)

    try {
      console.log("📝 Iniciando proceso de registro...")

      // Crear usuario en Firebase
      const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password)

      // Actualizar perfil con nombre completo
      await updateProfile(userCredential.user, {
        displayName: `${formData.nombre} ${formData.apellido}`,
      })

      console.log("✅ Registro exitoso:", userCredential.user.email)

      setRegisterStatus("¡Registro exitoso! Ahora puedes iniciar sesión.")

      // Llamar callback si existe
      if (onRegister) {
        onRegister(userCredential.user)
      }

      // Limpiar formulario
      setFormData({
        nombre: "",
        apellido: "",
        email: "",
        password: "",
        confirmPassword: "",
      })
    } catch (error) {
      console.error("❌ Error en registro:", error)

      // Manejar errores específicos de Firebase
      let errorMessage = "Error al registrar usuario"
      switch (error.code) {
        case "auth/email-already-in-use":
          errorMessage = "Este email ya está registrado"
          break
        case "auth/weak-password":
          errorMessage = "La contraseña es muy débil"
          break
        case "auth/invalid-email":
          errorMessage = "Email inválido"
          break
        default:
          errorMessage = error.message || "Error al registrar usuario"
      }

      setRegisterStatus(errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="auth-form-container">
      <div className="auth-form-header">
        <h2>Crear cuenta nueva</h2>
        <p>Únete a nuestra plataforma de nube empresarial</p>
      </div>

      <form className="auth-form" onSubmit={handleRegister}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="nombre">Nombre</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              placeholder="Tu nombre"
              value={formData.nombre}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="apellido">Apellido</label>
            <input
              type="text"
              id="apellido"
              name="apellido"
              placeholder="Tu apellido"
              value={formData.apellido}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="email">Correo Electrónico</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="tu@empresa.com"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Mínimo 6 caracteres"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword">Confirmar Contraseña</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            placeholder="Repite tu contraseña"
            value={formData.confirmPassword}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-terms">
          <label className="terms-checkbox">
            <input type="checkbox" required />
            <span>
              Acepto los{" "}
              <a href="#terms" className="terms-link">
                términos y condiciones
              </a>{" "}
              y la{" "}
              <a href="#privacy" className="terms-link">
                política de privacidad
              </a>
            </span>
          </label>
        </div>

        <button type="submit" className={`auth-button ${isLoading ? "loading" : ""}`} disabled={isLoading}>
          {isLoading ? (
            <>
              <div className="button-spinner"></div>
              Creando cuenta...
            </>
          ) : (
            "Crear Cuenta"
          )}
        </button>
      </form>

      {registerStatus && (
        <div className={`auth-status ${registerStatus.includes("exitoso") ? "success" : "error"}`}>
          {registerStatus}
        </div>
      )}
    </div>
  )
}
